import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { Loader } from 'components/common/Loader';
import { useScheduleInspectionMutation } from 'redux/services/inspection';
import { ProjectDetails } from '../ConductInspection/components/ProjectDetails';
import toast from 'react-hot-toast';
import './ScheduleInspection.scss';
import { useGetChecklist } from 'hooks/useGetChecklist';
import { useSetDropdownAndRole } from 'hooks/useSetDropdownAndRole';
import { useDispatch } from 'react-redux';
import { setProjectDetails } from 'redux/conductInspectionSlice';
import { useTranslation } from 'react-i18next';

const ScheduleInspection = () => {
  const { t } = useTranslation();
  const [scheduleInspection, { isLoading: isScheduleInspectionLoading }] =
    useScheduleInspectionMutation();
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useGetChecklist();
  const { project, isLoading } = useSetDropdownAndRole();

  useEffect(() => {
    return () => {
      dispatch(setProjectDetails(null));
    };
  }, [dispatch]);

  const handleProjectDetailsSubmit = async (values: any) => {
    const res: any = await scheduleInspection({
      id: values.id,
      projectId: values.projectId,
      subProject: values.subProject
        ? {
            name: values.subProject.name,
          }
        : undefined,
      subTask: values.subTask
        ? {
            name: values.subTask.name,
          }
        : undefined,
      endTask: values.endTask
        ? {
            name: values.endTask.name,
          }
        : undefined,
      selectedChecklist: {
        _id: values.selectedChecklist._id,
        name: values.selectedChecklist.name,
      },
      locations: values.locations,
      inspector: {
        userId: values.selectedInspector.userId,
      },
      scheduledDate: moment(values.scheduledTime).toISOString(),
    });
    if (res.data) {
      navigate(`/project/${projectId}/inspection`);
      toast.success(t('success_create_schedule_inspection'));
    } else {
      toast.error(res.error?.data?.message ?? t('something_went_wrong'));
    }
  };

  return (
    <div className="schedule-inspection d-flex">
      <div className="page-title">
        <h2 className="page-title">{t('header_schedule_inspection')}</h2>
      </div>
      <div className="d-flex flex-column setup-container">
        {project && (
          <ProjectDetails
            project={project!}
            schedule
            onSubmit={handleProjectDetailsSubmit}
          />
        )}
        {(isLoading || isScheduleInspectionLoading) && <Loader />}
      </div>
    </div>
  );
};

export default ScheduleInspection;
